import { services } from '@comall-backend-builder/core';
import { logout as logoutFun } from './logout';
import { getStore } from '@comall-backend-builder/core/lib/store';
import { actions } from '@comall-backend-builder/core';
import { localStorage } from '@comall-backend-builder/core/lib/services';
const api = services.api;
const statusCode = services.statusCode;

/**
 * 错误结构
 */
type ErrorResponse = {
    status: number;
    statusCode?: number;
};
services.swizzle(api, {
    errorHandle(error: ErrorResponse) {
        // @ts-ignore
        error.statusCode = statusCode[error.status];
        if (error.status === statusCode.UNAUTHORIZED) {
            localStorage.remove('user');
            getStore().dispatch(actions.logoutSuccessAction());
            window.location.href = ENV.REDIRECT_URI_BACK;
        }
        return Promise.reject(error);
    },
});
